import React from "react";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import classes from './textfield/input.module.scss'

const PhoneInputs = (props: any) => {
    const { node, data, change } = props;
    const setPhoneNumber = (value: any) => {

        let updateData = [...data];
        let filter: any;
        filter = updateData.filter((n: any) => {
            return n.name === node.name;
        });
        if (value >= 0) {
            if (filter[0]) {
                value === 0 ? filter[0].value = 1 : filter[0].value = value;
            }
        }
        change([...updateData])

    }
    return <div className={classes.textGroup}>
        <div className={classes.textdesign}>
            {node.title}
        </div>
        <div className={classes.phone}>
            <PhoneInput
                country={'us'}
                inputProps={{
                    name: 'phone',
                    required: true
                }}
                autoFormat={true}
                value={node.value}
                onChange={phone => setPhoneNumber(phone)}

            />
        </div>

    </div>
}

export default PhoneInputs